import {getApiList} from "@/api/backend";
import {factoryMutations, factoryState} from "@/store/Modules/_factoryList";

const state = JSON.parse(JSON.stringify(factoryState));

const mutations = {
  ...factoryMutations,
};

const actions = {
  async fetchList(context, {token, page}) {
    try {
      const list = (await getApiList('/operators', token, {page}));
      const result = list.items.map(
        ({ id, username, active, email, roles }) => ({
          id,
          username,
          active: active ? 'TAK' : 'NIE',
          email,
          roles: roles.map( r => r.replace(/ROLE_/, '')).join(', '),
        })
      );

      return context.commit('setItems', {items: result, totalItems: list.totalItems});
    } catch ({response}) {
      return context.commit('setApiError', {isError: true, status: response?.status});
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
